// تسميات مستند الطلب المطبوع (ثنائية اللغة) — مستقلة عن i18n لأن الـHTML يُحقن في نافذة/طبقة.
import { COMMON } from "../payroll/reportLabelsCommon";

const LEAVE_AR = { annual: "سنوية", sick: "مرضية", emergency: "طارئة", unpaid: "بدون راتب", time_off: "إجازة زمنية" };
const LEAVE_EN = { annual: "Annual", sick: "Sick", emergency: "Emergency", unpaid: "Unpaid", time_off: "Time-off" };
const TOFF_AR = { start_delay: "تأخير بداية الدوام", early_leave: "انصراف مبكر", mid_day: "خروج أثناء الدوام" };
const TOFF_EN = { start_delay: "Late start", early_leave: "Early leave", mid_day: "Mid-day leave" };
const STAT_AR = { pending: "قيد المراجعة", approved: "مقبول", rejected: "مرفوض", completed: "مكتملة",
  cancelled: "ملغاة", cancel_requested: "طلب إلغاء", expired: "منتهية" };
const STAT_EN = { pending: "Pending", approved: "Approved", rejected: "Rejected", completed: "Completed",
  cancelled: "Cancelled", cancel_requested: "Cancel requested", expired: "Expired" };

export const RL = {
  ar: {
    ...COMMON.ar, print: "طباعة", none: "—", refLabel: "الرقم المرجعي:",
    field: "البند", value: "التفاصيل", generatedAt: "تاريخ الإصدار",
    titles: { leave: "طلب إجازة", advance: "طلب سلفة", resignation: "طلب استقالة",
      timeOff: "طلب إجازة زمنية", resume: "طلب استئناف دوام" },
    type: "النوع", from: "من تاريخ", to: "إلى تاريخ", days: "عدد الأيام", paidUnpaid: "مدفوعة / بدون راتب",
    amount: "المبلغ", months: "أشهر السداد", installment: "القسط الشهري", noticeDays: "أيام الإشعار",
    submittedOn: "تاريخ التقديم", lastDay: "آخر يوم عمل", requestDate: "تاريخ الطلب", hours: "الساعات",
    window: "الفترة الزمنية", reason: "السبب", statusLabel: "الحالة", decisionNote: "ملاحظة القرار",
    decidedBy: "القرار من", signTitle: "التوقيع والاعتماد", signNameDate: "الاسم والتاريخ",
    signRoles: ["مقدّم الطلب", "المدير المباشر", "الموارد البشرية"],
    footer: "صدر هذا المستند إلكترونياً من نظام HELCOO لإدارة الموارد البشرية.",
    leaveTypes: LEAVE_AR, timeOffTypes: TOFF_AR, statuses: STAT_AR,
  },
  en: {
    ...COMMON.en, print: "Print", none: "—", refLabel: "Reference:",
    field: "Field", value: "Details", generatedAt: "Issued on",
    titles: { leave: "Leave request", advance: "Advance request", resignation: "Resignation request",
      timeOff: "Time-off request", resume: "Resume request" },
    type: "Type", from: "From", to: "To", days: "Days", paidUnpaid: "Paid / Unpaid",
    amount: "Amount", months: "Repayment months", installment: "Monthly installment", noticeDays: "Notice days",
    submittedOn: "Submitted on", lastDay: "Last working day", requestDate: "Request date", hours: "Hours",
    window: "Time window", reason: "Reason", statusLabel: "Status", decisionNote: "Decision note",
    decidedBy: "Decided by", signTitle: "Signatures and approval", signNameDate: "Name and date",
    signRoles: ["Requested by", "Direct manager", "HR"],
    footer: "This document was issued electronically by the HELCOO HR system.",
    leaveTypes: LEAVE_EN, timeOffTypes: TOFF_EN, statuses: STAT_EN,
  },
};
